module.exports = __webpack_public_path__ + "images/emoji/evergreen_tree.7def3f4e75296d3c456b.png";